// FOLLOWUP COUNT API
import Request from '../base'
export default {
  countOrg (options) {
    return Request.post('/ebercount/countapi/followup/count/org', options)
  },
  volumeCountOrg (options) {
    return Request.post('/ebercount/countapi/followupVolume/count/org', options)
  },
  exportVolumeCount (options) {
    return Request.download('/ebercount/countapi/followupVolume/count/export', options)
  }


}
